import { BLOG_LANGUAGES, DEFAULT_LANGUAGE } from '@wix/communities-blog-client-common';

export const validateLanguage = (language: string) =>
  BLOG_LANGUAGES.includes(language.slice(0, 2)) ? language : DEFAULT_LANGUAGE;
